import React from 'react';

// A flat, label-over-value tile. Renders "—" for null/undefined so a
// still-loading or backend-shape-mismatch state doesn't display garbage.
export const StatCard = ({ label, value, hint }) => {
  const display = value === null || value === undefined ? '—' : Number(value).toLocaleString();
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 min-w-[140px]">
      <div className="text-[12px] uppercase tracking-wide text-gray-500">{label}</div>
      <div className="text-[28px] font-semibold leading-tight mt-1">{display}</div>
      {hint ? <div className="text-[11px] text-gray-400 mt-1">{hint}</div> : null}
    </div>
  );
};
